import React, {Suspense} from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

const Login = React.lazy(() => import('./login/login'));
const Admin = React.lazy(() => import('./sign/sign'));
const Skema = React.lazy(() => import('./skema/skema'));

class App extends React.Component{
    render(){
        return(
            <Router>
                <Suspense fallback={
                    <div className="sk-chase">
                        <div className="sk-chase-dot"></div>
                        <div className="sk-chase-dot"></div>
                        <div className="sk-chase-dot"></div>
                        <div className="sk-chase-dot"></div>
                        <div className="sk-chase-dot"></div>
                        <div className="sk-chase-dot"></div>
                    </div>
                }>
                    <Switch>
                        <Route exact path="/">
                            <Redirect to="/login" />
                        </Route>
                        <Route path="/login">
                            <Login />
                        </Route>
                        <Route path="/admin">
                            <Admin/>
                        </Route>
                        <Route path="/skema-satu">
                            <Skema skema="SCHEME01" />
                        </Route>
                        <Route path="/skema-dua">
                            <Skema skema="SCHEME02" />
                        </Route>
                    </Switch>
                </Suspense>
            </Router>
        );
    }
}

export default App;